import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  OverlayTrigger,
  Tooltip as BSTooltip,

} from "react-bootstrap";
import dayjs from "dayjs";
import { MdAddCircle } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import AppDataGrid from '../../components/common/AppDataGrid';
import axios from "axios";
import DataTable from "react-data-table-component";
import { ToastContainer } from "react-toastify";
import loading from "../../assets/images/common/loading.gif";
import { Tooltip } from "@mui/material";

const FeeReceiptsMain = () => {
  const [feeData, setFeeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [scheduleDetails, setScheduleDetails] = useState([]);
  const [receiptDetails, setReceiptDetails] = useState([]);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const userObj = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    fetchData();
  }, []);
  const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge", "Principal"];
  const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());
  const fetchData = async () => {
    try {
      const response = await axios.post(
        baseUrl + "/getfeestudentreceiptstructure/",
        {
          p_school_id: userObj.school_id,
          p_academic_year_id: userObj.academic_year_id,
        }
      );
      setFeeData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching fee data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchScheduleDetails = async (student_id) => {
    try {
      const res = await axios.get(baseUrl + "/main/getstudentfeedetail", {
        params: {
          _school_id: userObj.school_id,
          _academic_year_id: userObj.academic_year_id,
          _student_id: student_id,
          user_id:userObj.user_id
        }
      });

      const schedules = res.data?.[0]?.getstudentfeedetail?.schedules || [];
      setScheduleDetails(schedules);
    } catch (err) {
      console.error("Error loading schedule details:", err);
      setScheduleDetails([]);
    }
  };



  const fetchReceiptDetails = async (student_id) => {
    try {
      const res = await axios.post(baseUrl + "/getfeereciepts/", {
        school_id: userObj.school_id,
        academic_year_id: userObj.academic_year_id,
        student_id,
      });
      setReceiptDetails(res.data || []);
    } catch (err) {
      console.error("Error loading receipt details:", err);
    }
  };

  const handleTotalClick = (student) => {
    setSelectedStudent(student);
    fetchScheduleDetails(student.student_id);
    setShowScheduleModal(true);
  };

  const handlePaidClick = (student) => {
    setSelectedStudent(student);
    fetchReceiptDetails(student.student_id);
    setShowReceiptModal(true);
  };

  // Main grid (Fee Receipts) — DataGrid style
  const columns = [
    {
      field: 'admission_number',
      headerName: 'Admission Number',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: 'student_name',
      headerName: 'Student Name',
      flex: 1.2,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: 'class_name',
      headerName: 'Class',
      flex: 0.8,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: 'total_fee',
      headerName: 'Total Fee',
      flex: 0.9,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span
            className="hyperlink"
            style={{ cursor: 'pointer', color: 'blue' }}
            onClick={() => handleTotalClick(params.row)}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'total_paid',
      headerName: 'Paid Amount',
      flex: 0.9,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span
            className="hyperlink"
            style={{ cursor: 'pointer', color: 'green' }}
            onClick={() => handlePaidClick(params.row)}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'balance',
      headerName: 'Balance',
      flex: 0.9,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
  ];


  const searchableColumns = [
    (row) => row.admission_number,
    (row) => row.student_name,
    (row) => row.class_name,
  ];

  const filteredRecords = (feeData || []).filter((item) =>
    searchableColumns.some((selector) => {
      const value = selector(item);
      const stringValue = String(value || "").toLowerCase().replace(/[-\s]+/g, "");
      const normalizedQuery = searchQuery.toLowerCase().replace(/[-\s]+/g, "");
      return stringValue.includes(normalizedQuery);
    })
  );

  // Columns for schedule modal
  // Schedule modal columns — DataGrid style
  const scheduleColumns = [
    {
      field: 'schedule_name',
      headerName: 'Schedule Name',
      flex: 1.2,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'scheduled_amount',
      headerName: 'Scheduled Amount',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'amount_paid',
      headerName: 'Amount Paid',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'balance_amount_to_be_paid',
      headerName: 'Balance',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => {
        const row = params.row;
        const isOverdue =
          row.balance_amount_to_be_paid > 0 &&
          dayjs(row.due_date, 'DD/MM/YYYY').isBefore(dayjs(), 'day');
        return (
          <Tooltip title={row.balance_amount_to_be_paid}>
            <span style={{ color: isOverdue ? 'red' : 'inherit' }}>
              {row.balance_amount_to_be_paid}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: 'due_date',
      headerName: 'Due Date',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
  ];

  // Columns for receipt modal
  // Receipt modal columns — DataGrid style
  const receiptColumns = [
    {
      field: 'fee_receipt_no',
      headerName: 'Receipt No',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'reciept_date',
      headerName: 'Receipt Date',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'mode',
      headerName: 'Mode',
      flex: 0.8,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'amount_paid',
      headerName: 'Paid Amount',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      flex: 1.2,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
    },
  ];


  return (





    <div className="pageBody">
      <ToastContainer />
      <div className="commonDataTableHead">
        <div className="d-flex justify-content-between align-items-center w-100">
          <h6 className="commonTableTitle">Fee Receipts</h6>
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            className="searchInput"
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {canSubmit && (
            <OverlayTrigger
              placement="top"
              overlay={<BSTooltip id="tooltip-top">Add</BSTooltip>}
            >
              <Button
                className="primaryBtn"
                variant="primary"
                onClick={() => navigate("/addfeereceipts")}
              >
                <MdAddCircle />
              </Button>
            </OverlayTrigger>)}
        </div>
      </div>
      <div className="commonTable height100">
        <div className="tableBody">
          {isLoading ? (
            <div className="loadingContainer">
              <img src={loading} alt="Loading..." className="loadingGif" />
            </div>
          ) : (
            <AppDataGrid
              rows={filteredRecords?.length ? filteredRecords : []}
              columns={columns}
              getRowId={(row) => row.student_id ?? row.admission_number ?? row.id}
              pageSizeOptions={[10, 20, 50]}
              showToolbar={false}
              pagination
              density="compact"
              maxHeight={550}
            />

          )}
        </div>
      </div>



      {/* Schedule Modal */}
      <Modal show={showScheduleModal} onHide={() => setShowScheduleModal(false)} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Schedule Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AppDataGrid
            rows={scheduleDetails?.length ? scheduleDetails : []}
            columns={scheduleColumns}
            getRowId={(row) => row.schedule_id ?? row.id ?? `${row.schedule_name}-${row.due_date}`}
            pageSizeOptions={[10, 20, 50]}
            showToolbar={false}
            pagination
            density="compact"
            maxHeight={400}
          />

        </Modal.Body>
      </Modal>

      {/* Receipt Modal */}
      <Modal show={showReceiptModal} onHide={() => setShowReceiptModal(false)} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Receipt Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AppDataGrid
            rows={receiptDetails?.length ? receiptDetails : []}
            columns={receiptColumns}
            getRowId={(row) => row.fee_receipt_no ?? row.id}
            pageSizeOptions={[10, 20, 50]}
            showToolbar={false}
            pagination
            density="compact"
            maxHeight={400}
          />

        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FeeReceiptsMain;
